import styled from '@emotion/styled'
import { pxToRem } from 'utils/styled'

export const SInfiniteLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(24)}rem;
`
